

export default {
  name: 'ListingProductsCount',
  props: {
    itemsCount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('en'),
    };
  },
  computed: {
    formattedCount() {
      return this.formatter.format(this.itemsCount);
    },
  },
};
